
//
const zenoFetch = require('../utils/zenoFetch.js');

//
const validationTests = {};

//define a whole bunch of regex
const isEmailRegex        = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
const isAlphanumericRegex = /^[A-Za-z0-9]+$/i;
const isAlphaRegex        = /^[A-Za-z]+$/;
const isUrlRegex          = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i;
const isIPv4Regex         = /^(?:(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/;
const isIPv6Regex         = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i;
const isDateRegex         = /^(?:\2)(?:[0-9]{2})?[0-9]{2}([\/-])(1[0-2]|0?[1-9])([\/-])(3[01]|[12][0-9]|0?[1-9])$/;
const isTimeRegex         = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/;
const isNumberRegex       = /^\s*(\+|-)?((\d+(\.\d+)?)|(\.\d+))\s*$/;
const isPasswordRegex     = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{10,}$/;

//apply validation to every form which is built using the form system
document.querySelectorAll('[data-form-validation]').forEach((form) => {

    //apply the onchange and other events to the fields on the form
    applyDynamicValidationToFields(form);

    //
    form.addEventListener('submit', async (event) => {

        //
        event.preventDefault();

        //this is remains true at end if all the fields are validated successfully
        let validationPassed = true;

        //
        for (const input of form.querySelectorAll('.input-group')) {

            //
            let validation = null;

            //only do something if there is a validation attribute and there is one of the specific elements in the input group
            if (input.dataset.validation !== undefined && input.querySelector('input, textarea, select option:checked')) {

                let valueInputFromUser = null;
                validation = JSON.parse(input.dataset.validation);

                //If the input is a checkbox then validation is based on number of checkboxes checked
                if (input.querySelector('input[type="checkbox"]')) {
                    valueInputFromUser = getCheckedCount(input);
                    if (valueInputFromUser == 0) {
                        valueInputFromUser = '';
                    }
                }
                //If the input is a radio then if nothing is checked set value to empty string
                else if (input.querySelector('input[type="radio"]')) {
                    if (input.querySelector('input[type="radio"]:checked') == null) {
                        valueInputFromUser = '';
                    }
                    else {
                        valueInputFromUser = input.querySelector('input[type="radio"]:checked').value;
                    }
                }
                else {
                    valueInputFromUser = input.querySelector('input, textarea, select option:checked').value;
                }

                //validate field
                let thisFieldPassed = await validateField(validation, valueInputFromUser, input);

                //If any field fails to be validated then set validationPassed flag to false
                if (validationPassed == true && thisFieldPassed == false) {
                    validationPassed = false;
                }

            }

        }

        //If JavaScript validation passes then submit the form.
        if (validationPassed) {
            if (typeof form.nrlaSubmitCallback == 'function') {
                form.nrlaSubmitCallback();
            } else {
                form.submit();
            }
        }

        //scroll to the highest error input field
        if (validationPassed == false) {
            for (let input of form.querySelectorAll('.input-group')) {
                if (input.classList.contains('input-error')) {

                    //
                    let inputToScrollTo = input;

                    //get the nearest visible parent element
                    while (inputToScrollTo.checkVisibility() == false) {
                        inputToScrollTo = inputToScrollTo.parentElement;
                    }

                    //
                    inputToScrollTo.scrollIntoView({ 'behavior': 'smooth', 'block': 'start', 'inline': 'nearest' });
                    break;

                }
            }
        }

    });

});

/**
 * Function to validate a field returns true if validated
 * @param  object validation            Required - An array of objects with rules and message properties
 * @param  string valueInputFromUser    Required - The value input to the field by the user
 * @param  object input                 Required - Reference to the input element to show error message
 * @return bool
*/
async function validateField(validation, valueInputFromUser, input) {

    //
    for (const rule of validation) {

        //check when condition (field operator value)
        if (rule.hasOwnProperty('when')) {

            //
            match = rule.when.match(/^(.+?) (==|!=|not in|in|>=|<=|>|<)(?: \(?)?([^\(\)\n]+)(?:\))?$/);

            //
            if (match) {

                //
                const whenField    = match[1].trim();
                const whenOperator = match[2].trim();
                const whenValue    = match[3].trim();

                //get field value
                const whenFieldValue = document.querySelector(`input[name="${whenField}"]:not([type="radio"]), input[name="${whenField}"][type="radio"]:checked, select[name="${whenField}"], textarea[name="${whenField}"]`)?.value;

                //convert operator to a function
                operators = {
                    '=='     : (a, b) => a == b,
                    '!='     : (a, b) => a != b,
                    '>'      : (a, b) => a > b,
                    '<'      : (a, b) => a < b,
                    '>='     : (a, b) => a >= b,
                    '<='     : (a, b) => a <= b,
                    'in'     : (a, b) => b.includes(a),
                    'not in' : (a, b) => !b.includes(a),
                }

                //if the when condition does not match - then skip validation
                if (operators.hasOwnProperty(whenOperator) && operators[whenOperator](whenFieldValue, whenValue) === false) {
                    return;
                }

            }

        }

        //
        const tests = JSON.parse(rule.rules);

        //if the rule list does not contain is required rule and the value from user is empty then don't show error message.
        const isRequiredArray = tests.filter((test) => { return test.includes('is_required'); } );
        if (isRequiredArray.length == 0 && (valueInputFromUser == '' || valueInputFromUser == undefined)) {
            return true;
        }

        //
        const result = await Promise.all(tests.map(async (test) => {

            //if the test is not defined, skip it as it's not been implemented on the client
            if (!validationTests.hasOwnProperty(test[0])) {
                console.warn(`The test called "${test[0]}" is not implemented on the client and will be validated on the server only.`);
                return true;
            }

            //
            return await validationTests[test[0]].apply(this, [ valueInputFromUser, ...test.slice(1) ]);

        }));

        //
        const didValueValidate = result.every((r) => r === true);

        //show error if the rule fails and set flag to true
        if (didValueValidate == false) {

            //
            input.querySelector('.input-error-message').innerHTML = rule.message;
            input.classList.add('input-error');

            //
            return false;

        }

        //if the input was showing an error before but the new input is valid then remove the error message and styles
        if (didValueValidate == true && input.classList.contains('input-error')) {
            removeErrorStyles(input);
        }

    }

    //
    return true;

}

/**
 * Add a test to the validation system
 */
function addValidationTest(name, callback) {
    validationTests[name] = callback;
}

//define the rules to be used in the validation system
addValidationTest('is_required', (input) => {
    return !!input;
});

//
addValidationTest('is_email', (input) => {
    return isEmailRegex.test(input);
});

//
addValidationTest('isPhoneNumber', (input) => {
    return (new RegExp('^[0-9 \\-\(\)\+]+$')).test(input) && input.replaceAll(/[^0-9]/g, '').length >= 4;
});

//
addValidationTest('min_length', (input, min) => {
    return typeof input === 'string' && input.length >= min;
});

//
addValidationTest('max_length', (input, max) => {
    return typeof input === 'string' && input.length <= max;
});

//
addValidationTest('min_value', (input, min) => {
    return input >= min;
});

//
addValidationTest('max_value', (input, max) => {
    return input <= max;
});

//
addValidationTest('is_alphanumeric', (input) => {
     return isAlphanumericRegex.test(input);
});

//
addValidationTest('is_alpha', (input) => {
     return isAlphaRegex.test(input);
});

//
addValidationTest('is_url', (input) => {
    return isUrlRegex.test(input);
});

//
addValidationTest('is_ipv4', (input) => {
    return isIPv4Regex.test(input);
});

//
addValidationTest('is_ipv6', (input) => {
    return isIPv6Regex.test(input);
});

//
addValidationTest('is_date', (input) => {

    //
    if (!isDateRegex.test(input)) {
        return false;
    }

    //define the valid date range
    const minDate = new Date('1753-01-01');
    const maxDate = new Date('9999-12-31');

    //
    const date = new Date(input);

    //
    return date >= minDate && date <= maxDate;

});

//
addValidationTest('is_time', (input) => {
    return isTimeRegex.test(input);
});

//
addValidationTest('is_number', (input) => {
    return isNumberRegex.test(input);
});

//
addValidationTest('is_password', (input) => {
    return isPasswordRegex.test(input);
});

//
addValidationTest('isValidYearOfBirth', (input) => {
    return !isNaN(parseInt(input, 10)) && ((new Date().getFullYear()) - parseInt(input, 10)) >= 18 && parseInt(input, 10).toString().length == 4;
});

//
addValidationTest('is_emailalreadyused', async (input, ignoreCurrentUser = true) => {
    const [ status, response ] = await zenoFetch('post', '/api/check-email-already-used', null, { 'email' : input, ignoreCurrentUser });
    if (status == 'success' && response.isEmailAlreadyUsed == true) {
        return false;
    }
    return true;
});

/**
 * Shows an error on the field as its value is changed
 * @param  object form  Required - A reference to the form
 * @return void
*/
function applyDynamicValidationToFields(form) {
    form.querySelectorAll('.input-group').forEach(input => {

        //If validation is not defined there is not input or select in the input group then return immediately
        if (!(input.dataset.validation !== undefined && input.querySelector('input, textarea, select'))) {
            return
        }

        //only do something now if there is a validation attribute and there is one of the specific elements in the input group
        let validation = JSON.parse(input.dataset.validation);
        let timeOutID = null;   //For storing the setTimeout ID

        //used to keep track of the name attribute for element in focus and previous element in focus
        let focusElementNameNow = null;
        let prevFocusedElementName = null;

        //check if the input group is for a checkbox
        if (input.hasAttribute('data-checkbox-group')) {

            let checkboxes = input.querySelectorAll('input[type="checkbox"]');

            checkboxes.forEach(checkbox => {

                //Remove error styles when focus has gained and clear timeout
                checkbox.addEventListener('focusin', function(event) {

                    //
                    focusElementNameNow = checkbox.getAttribute('name');
                    let inputGroup = this.closest('.input-group');

                    //
                    clearTimeout(timeOutID);

                });

                //Try to validate the field after timeout when focus is lost
                checkbox.addEventListener('blur', function(event) {

                    //
                    prevFocusedElementName = checkbox.getAttribute('name');
                    focusElementNameNow = null;
                    valueInputFromUser = getCheckedCount(input);

                    //if number of checked is 0 then turn into empty string for the is required rule
                    if (valueInputFromUser == 0) {
                        valueInputFromUser = '';
                    }

                    //
                    let inputGroup = this.closest('.input-group');

                    //Try to validate the field in 500ms only if the new focus element name is different
                    timeOutID = setTimeout(() => {
                        if (prevFocusedElementName != focusElementNameNow) {
                            validateField(validation, valueInputFromUser, inputGroup);
                        }
                    }, 500);

                });

            });

            return;
        }

        //if any inputs loose focus, start a timer to validate the input group
        input.querySelectorAll('input:not([type="checkbox"]), textarea, select').forEach((element) => {
            element.addEventListener('blur', function(event) {

                //
                prevFocusedElementName = this.getAttribute('name');
                focusElementNameNow = null;
                let valueInputFromUser = this.value;
                let inputGroup = this.closest('.input-group');

                //Try to validate the field in 500ms
                timeOutID = setTimeout(() => {
                    validateField(validation, valueInputFromUser, inputGroup);
                }, 500);

            });
        });

        //if any field in the input group gains focus back, then stop the error validation from triggering
        input.querySelectorAll('input:not([type="checkbox"]), textarea, select').forEach((element) => {
            element.addEventListener('focus', function(event) {
                focusElementNameNow = this.getAttribute('name');
                clearTimeout(timeOutID);
            });
        });

    });
}

/**
 * Removes the error message error class from the input group
 * @param  object form  Required - Reference to the input-group
 * @return void
*/
function removeErrorStyles(input) {
    input.querySelector('.input-error-message').textContent = '';
    input.classList.remove('input-error');
}

/**
 * Returns the count of checkboxes checked in the input
 * @param  object input  Required - Reference to the input-group
 * @return int
*/
function getCheckedCount(checkboxField) {
    let count = 0;
    checkboxField.querySelectorAll('.input-option-label').forEach(checkbox => {
        let input = checkbox.querySelector('input[type="checkbox"]');
        if (input.checked) {
            count++;
        }
    });
    return count;
}
